module.exports = "<sx-listado-desplegable \r\n[fuente]=\"grupos\"\r\n[tipo]=\"'PRODUCTO' | translate\">\r\n</sx-listado-desplegable>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/product/product.setup.component.html
// module id = ../../../../../src/app/private/configuracion/product/product.setup.component.html
// module chunks = main